export default {
  path: 'upload',
  meta: {
    requiresAuth: true,
    requiresRoAccess: true
  },
  component: () => import('./UploadTab')
}
